import { Link } from "react-router-dom";
import { articleList } from "@/mocks/article";

export default function ArticleCards() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            AllChinaBuy Spreadsheet Guides
          </h2>
          <p className="text-foreground-600 text-base md:text-lg">
            In-depth shopping guides to help you get the most from the allchinabuy sheet directory
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group bg-background-100 border border-background-200/70 rounded-2xl overflow-hidden hover:border-accent-300 transition-all cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-accent-600 whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}